<template>
    <div class="container" :class="{'no-middle-step': referral !== 'GEN1'}">
        <div class="box">
            <img
                src="@/assets/progress-bar/p-details.png"
                alt="personal details"
                :class="{ completed: submissionStep === 2 || submissionStep === 3}"
            >
            <label class="details-label">{{ $t('SubmissionProgressBar.details') }}</label>
        </div>
        <div v-if="referral === 'GEN1'" class="box">
            <img
                src="@/assets/progress-bar/prof-pref.png"
                alt="professional preferences"
                :class="{ completed: submissionStep === 3 }"
            >
            <label class="prof-label">{{ $t('SubmissionProgressBar.profPref') }}</label>
        </div>
        <div class="box">
            <img
                src="@/assets/progress-bar/cv-send.png"
                alt="cv-send"
            >
            <label class="cv-label">{{ $t('SubmissionProgressBar.cvSend') }}</label>
        </div>
        <div class="line" />
    </div>
</template>

<script>
    export default {
        name: 'SubmissionProgressBar',
        props: {
            submissionStep: {
                type: Number,
                required: true,
                default: 1
            },
            referral: {
                type: String,
                required: false,
                default: null
            }
        }
    }
</script>

<style scoped>
body {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}

.container {
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    position: relative;
    max-width: 1050px;
}

.container.no-middle-step {
    max-width: 750px;
}

.box {
    --box-size: 78px;
    --base-clr: #3897d0;

    display: flex;
    flex-direction: column;
    z-index: 2;
}

.box img {
    border: 1px solid var(--base-clr);
    height: var(--box-size);
    width: var(--box-size);
    background: #fff;
}

label {
    margin-top: 1rem;
    width: var(--box-size);
    color: var(--base-clr);
    text-align: center;
    font-size: 0.7rem;
}

.completed {
    background-image: url("~@/assets/progress-bar/completed.svg") !important;
}

.line {
    position: absolute;
    top: 30%;
    left: 10%;
    border-top: solid 1px #7c7c7c;
    width: 80%;
    z-index: 1;
}

@media screen and (min-width: 480px) {
    .box {
        --box-size: 124px;
    }

    label {
        margin-top: 2rem;
        font-size: 1.1rem;
        width: var(--box-size);
    }

    .box img {
        height: var(--box-size);
        width: var(--box-size);
    }
}

@media screen and (min-width: 768px) {
    .box {
        position: relative;
    }

    .box img {
        margin: 0 auto;
    }

    label {
        margin: 2rem auto 0;
        font-size: 1.1rem;
        width: 235px;
    }

    .line {
        top: 35%;
    }
}
</style>
